import { isEmptyList, logAnalyticsEvent, sortByField } from "../../utils";
import { ReactComponent as GroupCircle } from "../../assets/group-circle.svg";
import { useNavigate } from "react-router-dom";
import { useMainDispatchContext } from "../../MainContext";
import { ANALYTICS_EVENTS } from "../../constants";

function LiveRosterDepartments(props) {
  const { departments } = props;
  const navigate = useNavigate();
  const dispatch = useMainDispatchContext();
  sortByField(departments, "name");

  return (
    <div className="live-roster-departments">
      <div className="department-tiles">
        {!isEmptyList(departments) &&
          departments.map((department) => (
            <div
              className="department-tile"
              key={department.uuid}
              onClick={() => {
                navigate(`/live-roster/${department.uuid}`);
                logAnalyticsEvent(
                  dispatch,
                  ANALYTICS_EVENTS.LIVE_ROSTER_SELECT_DEPARTMENT
                );
              }}
            >
              <div>
                <div className="department-icon">
                  <GroupCircle />
                </div>
                <div className="department-name">{department.name}</div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default LiveRosterDepartments;
